import { render, staticRenderFns } from "./EditDancer.vue?vue&type=template&id=771f6984&scoped=true&"
import script from "./EditDancer.vue?vue&type=script&lang=js&"
export * from "./EditDancer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771f6984",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771f6984')) {
      api.createRecord('771f6984', component.options)
    } else {
      api.reload('771f6984', component.options)
    }
    module.hot.accept("./EditDancer.vue?vue&type=template&id=771f6984&scoped=true&", function () {
      api.rerender('771f6984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/EditDancer.vue"
export default component.exports